import { Wrench, RefreshCw, Building2 } from "lucide-react";
import { colors } from "./colors";

const SERVICES = [
  {
    icon: Wrench,
    title: "Montage von LED Lichtsystemen",
    text: "Professionelle Installation von LED Lichtbändern und Industriebeleuchtung in Hallen und Gewerbeobjekten.",
  },
  {
    icon: RefreshCw,
    title: "Modernisierung bestehender Beleuchtung",
    text: "Umrüstung alter Beleuchtungsanlagen auf energieeffiziente LED Systeme inklusive Demontage und fachgerechter Installation.",
  },
  {
    icon: Building2,
    title: "Projektumsetzung für Gewerbe und Industrie",
    text: "Planung und Umsetzung von Beleuchtungsprojekten in Industriehallen, Logistikzentren, Bürogebäuden und Handelsflächen.",
  },
];

export function PartnerSection() {
  return (
    <section className="py-20 md:py-24" style={{ backgroundColor: colors.white }} data-testid="partner-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h2 className="text-gray-900 font-bold text-xl md:text-2xl lg:text-3xl tracking-tight">
          Ihr Partner für professionelle Beleuchtungsprojekte
        </h2>
        <p className="mt-6 text-gray-500 text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
          Wir realisieren LED Beleuchtungsprojekte für Industrie, Logistik, Büro und Handelsflächen.
          Von der Modernisierung bestehender Anlagen bis zur vollständigen Installation neuer Beleuchtungssysteme.
        </p>
      </div>
    </section>
  );
}

export function ServicesSection() {
  return (
    <section id="leistungen" className="py-20 md:py-24" style={{ backgroundColor: "#f8f9fb" }} data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-12 text-center">
          <p className="text-blue-500/60 text-xs uppercase tracking-[0.2em] mb-3">Leistungen</p>
          <h2 className="text-gray-900 font-bold text-xl md:text-2xl lg:text-3xl tracking-tight">
            Unsere Leistungsbereiche
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {SERVICES.map((item) => (
            <div key={item.title} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
              <div
                className="inline-flex items-center justify-center w-12 h-12 rounded-lg mb-5"
                style={{ backgroundColor: `${colors.darkBlue}0a` }}
              >
                <item.icon className="w-6 h-6" style={{ color: colors.darkBlue }} strokeWidth={1.5} />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-gray-500 leading-relaxed text-sm">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
